import { createAction, props } from '@ngrx/store';

import { DeviceModel } from '@services/device_models.service';

export const getDeviceModels = createAction('[DeviceModels] Get');
export const storeDeviceModels = createAction(
  '[DeviceModels] Store',
  props<{ list: DeviceModel[] }>(),
);
